import { IOptionGroup } from 'src/types/menu.types';
import { DetailedOptionGroup } from 'src/api/getOptionGroup/types';

export const formatOptionGroup = (og: DetailedOptionGroup): IOptionGroup => ({
  optionGroupId: og.option_group_id,
  name: og.name,
  type: og.type,
  description: og.description ?? '',
  min: og.min_choices ?? 0,
  max: og.max_choices ?? 0,
  ranges: og.ranges ?? [],
  external_systems: og.external_systems ?? [],
  consumer_name: og.consumer_name,
  modification_date: og.modification_date,
  items: og.options.map((opt) => ({
    optionItemId: opt.item_id,
    itemId: opt.option_id,
    name: opt.name,
    posId: opt.plu,
    valueWithTax: opt.value_with_tax,
    inheritPrice: opt.inherit_price,
    min: opt.min_choices,
    max: opt.max_choices,
    default: opt.default_choice,
  })),
});
